import { useTranslation } from 'react-i18next';

const Restaurants = ({ comercios, ruta }) => {
    const { t } = useTranslation();
    return (
        <hotel-detail-swipper-restaurant>
            <div className="c-swiper-restaurants o-cont-fullw" id="restaurantes">
                <div className="container mb-6 mb-sm-80">
                    <h2 className="text-center h1">{t("Restaurantes y bares")}</h2>
                    <div className="mw-640">
                        <p className="text-lg text-center">{t("Espacios que se adaptan a tu momento vital, compartiendo una misma esencia y estándar de calidad")}</p>
                    </div>
                    <div className="c-rest-swiper_container">
                        <div init="false" className="c-rest-swiper sw-sm-noauto">
                            {
                                comercios.map((uncomercio, index) => (
                                    <div key={index} className="c-card restaurant swiper-slide-active" style={{ width: "410.667px", marginRight: "16px" }} role="group" aria-label="1 / 3" >
                                        <div className="c-card_img">
                                            {
                                                uncomercio.logo ?
                                                    <img className="img" src={ruta + "/comercios/" + uncomercio.id + "/logo/" + uncomercio.logo} alt={uncomercio.nombre} />
                                                    :
                                                    <img className="img" src="https://www.bedloop.com/imatges/logo.webp" alt={uncomercio.nombre} />
                                            }
                                            <h3 className="c-card_title">{uncomercio.nombre}</h3>
                                        </div>
                                        <p dangerouslySetInnerHTML={{ __html: uncomercio.notas }}></p>
                                        <p>
                                            <strong>Horario 07:00 - 10:30</strong>
                                        </p>

                                        <a target="_blank" className="mt-auto btn btn-link" href={uncomercio.web}> Web <span className="o-icon arrow">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                        {/*<button className="c-rest-swiper_container-btn swiper-button-next swiper-button-disabled swiper-button-lock" disabled="" tabIndex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-ca424705924f5dec" aria-disabled="true"></button>
                        <button className="c-rest-swiper_container-btn swiper-button-prev swiper-button-disabled swiper-button-lock" disabled="" tabIndex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-ca424705924f5dec" aria-disabled="true"></button>*/}
                    </div>
                </div>
            </div>
        </hotel-detail-swipper-restaurant>
    );
};

export default Restaurants;
